import React from 'react';
import PropTypes from 'prop-types';

import * as styles from './Button.module.scss';

const propTypes = {
  /**
   * Extra classes for module
   */
  classname: PropTypes.string,

  /**
   * Is this the principal call to action on the page?
   */
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'third',
    'fourth'
  ]),

  /**
   * Button size
   */
  size: PropTypes.oneOf([
    'small',
    'medium',
    'large'
  ]),

  /**
   * Button contents
   */
  content: PropTypes.string.isRequired,

  /**
   * Button link
   */
  url: PropTypes.string
};

const defaultProps = {
  variant: 'primary',
  size: 'large',
  content: 'Content'
};

/**
 * Primary UI component for user interaction
 */
const Button = ({
  classname,
  content,
  url,
  size,
  variant
}) => {
  const Component = url ? 'a' : 'span';

  return (
    <Component
      className={`${styles.root} ${styles[variant]} ${styles[size]} ${classname}`}
      href={`${url || ''}`}>
      {content}
    </Component>
  );
};

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
